module.exports = __webpack_public_path__ + "img/left-arrow.ad59ba45.svg";